import { requireSupabase } from './supabase';

export async function getPlans() {
  const client = await requireSupabase();
  const { data, error } = await client
    .from('plans')
    .select('*')
    .eq('active', true)
    .order('sort_order');
  if (error) throw error;
  return data;
}

export async function submitRecord(table, payload) {
  const client = await requireSupabase();
  const { data, error } = await client.from(table).insert(payload).select().single();
  if (error) throw error;
  return data;
}

export async function startCheckout(planId, acceptedTerms) {
  if (!acceptedTerms) throw new Error('Please accept the Terms and Privacy Policy.');
  const client = await requireSupabase();
  const { data, error } = await client.functions.invoke('create-checkout', {
    body: {
      planId,
      successUrl: `${window.location.origin}/#/account?checkout=success`,
      cancelUrl: `${window.location.origin}/#/pricing`
    }
  });
  if (error) throw error;
  window.location.assign(data.url);
}

export async function getPortalData(userId) {
  const client = await requireSupabase();
  const [subscriptions, payments, notifications, tickets] = await Promise.all([
    client.from('subscriptions').select('*, plans(*), licences(*)').eq('user_id', userId).order('created_at', { ascending: false }),
    client.from('payments').select('*').eq('user_id', userId).order('created_at', { ascending: false }),
    client.from('notifications').select('*').eq('user_id', userId).order('created_at', { ascending: false }).limit(8),
    client.from('support_requests').select('*').eq('user_id', userId).order('created_at', { ascending: false })
  ]);
  const error = subscriptions.error || payments.error || notifications.error || tickets.error;
  if (error) throw error;
  return {
    subscription: subscriptions.data?.[0],
    payments: payments.data || [],
    notifications: notifications.data || [],
    tickets: tickets.data || []
  };
}

export async function getAdminData() {
  const client = await requireSupabase();
  const [profiles, subscriptions, licences, payments, leads, tickets] = await Promise.all([
    client.from('profiles').select('*').order('created_at', { ascending: false }),
    client.from('subscriptions').select('*, profiles(*), plans(*)').order('created_at', { ascending: false }),
    client.from('licences').select('*').order('created_at', { ascending: false }),
    client.from('payments').select('*').order('created_at', { ascending: false }).limit(20),
    client.from('corporate_leads').select('*').order('created_at', { ascending: false }),
    client.from('support_requests').select('*, profiles(*)').order('created_at', { ascending: false })
  ]);
  const error = profiles.error || subscriptions.error || licences.error || payments.error;
  if (error) throw error;
  return {
    profiles: profiles.data || [],
    subscriptions: subscriptions.data || [],
    licences: licences.data || [],
    payments: payments.data || [],
    leads: leads.data || [],
    tickets: tickets.data || []
  };
}